<template>
    <div id="queryRecord" class="background-ash pl20 pr20 pb20">
        <!--搜索条件-->
        <div class="search_list background-white">
            <ul class="lists">
                <li>
                    <span>商品ID</span>
                    <el-input size="small" @keyup.native.enter="searchGetDataList" class="width180" v-model="getDataParam.productId" placeholder="请输入商品ID"></el-input>
                </li>
                <li>
                    <span>商品名称</span>
                    <el-input size="small" @keyup.native.enter="searchGetDataList" class="width180" v-model="getDataParam.productNameLike" placeholder="请输入商品名称"></el-input>
                </li>
				<li>
                    <span>反馈时间</span>
                    <el-date-picker  size="small" v-model="time1" type="daterange"  range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
                </li>
                <li>
                    <span>账号</span>
                    <el-input size="small" class="width180" v-model="getDataParam.mobileLike" placeholder="请输入账号"></el-input>
                </li>
                <li>
                    <span>地区</span>
                    <el-input size="small" class="width180" v-model="getDataParam.regionLike" placeholder="请输入地区"></el-input>
                </li>
                <li>
                    <span>平台</span>
                    <el-select size="small" class="select width100" collapse-tags v-model="getDataParam.platformCode" >
                        <el-option label="全部" value="all"></el-option>
                        <el-option v-for="item in platformList" :key="item.platformCode" :value="item.platformCode" :label="item.platformName"></el-option>
                    </el-select>
                </li>
				<li>
                    <span>状态</span>
                    <el-select size="small" class="select width100" collapse-tags v-model="getDataParam.status" >
                        <el-option label="全部" value="all"></el-option>
                        <el-option label="未处理" value="INIT"></el-option>
                        <el-option label="已处理" value="PROCESSED"></el-option>
                    </el-select>
                </li>
            </ul>
			<div class="btns">
                <el-button size="small" type="primary"  @click="searchGetDataList">搜索</el-button>
            </div>
        </div>
        <!--内容-->
        <div class="pt20 content">
            <!-- 表头操作 -->
            <div class="watchBar">
                <div class="left color-blue">
                    <span>共计错误条数{{totalCount||0}}条</span>
                </div>
                <div class="btns right">
                    <el-button size="small" class="export-right" type="primary" plain @click="getExport">导出</el-button>
                </div>
            </div>
            <div class="tab">
                <el-table ref="checkList"  size="mini" :data="dataList" tooltip-effect="dark" height="100%">
                    <el-table-column type="index" label="序号"></el-table-column>
                    <el-table-column label="查询账号" prop="account"></el-table-column>
                    <el-table-column label="企业名称" prop="companyName"></el-table-column>
                    <el-table-column label="商品ID">
                        <template slot-scope="scope">{{ scope.row.productId || '' }}</template>
                    </el-table-column>
                    <el-table-column label="商品名称" prop="name"></el-table-column>
                    <el-table-column label="厂家" prop="manufactur"></el-table-column>
                    <el-table-column label="规格" prop="specifications"></el-table-column>
                    <el-table-column label="批准文号" prop="licenseNumber"></el-table-column>
                    <el-table-column label="反馈时间" prop="gmtFeedback"></el-table-column>
                    <el-table-column label="地区" prop="region"></el-table-column>
                    <el-table-column label="平台" prop="platformName"></el-table-column>
                    <el-table-column label="商家" prop="store"></el-table-column>
                    <el-table-column label="平均价" prop="averagePrice"></el-table-column>
                    <el-table-column label="最低价" prop="lowerPrice"></el-table-column>
                    <el-table-column label="当前登录平台">
                        <template slot-scope="scope">
                            <el-button type="text" size="mini" v-if="scope.row.platformRefList && scope.row.platformRefList.length > 0" @click="platforms = scope.row.platformRefList, dialogTableVisible = true">{{ scope.row.platformRefList.length }}</el-button>
                            <span v-else>0</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="链接">
                        <template slot-scope="scope">
                            <el-button size="mini" type="text" v-if="scope.row.url" @click="copyFunc(scope.row.url)">复制</el-button>
                            <span v-else>暂无</span>
                            <!-- <span style="cursor:pointer;" @click="copyFunc(scope.row.url)">复制</span>
                            <input class="copy-content" type="text" :value="scope.row.url" :id="scope.row.id"/> -->
                        </template>
                    </el-table-column>
                    <el-table-column label="原因" prop="reason"></el-table-column>
                    <el-table-column label="状态" fxied="right">
                        <template slot-scope="scope">
                            <span v-if="scope.row.status=='PROCESSED'">已处理</span>
                            <el-button type="text" size="small" v-else @click="stateHandling(scope.row)">未处理</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="page background-white text-right p20">
                <el-pagination @size-change="changePageSize" @current-change="getDataList" :current-page.sync="getDataParam.page"
                :page-sizes="[10, 20, 50, 100]" :page-size="getDataParam.size" layout="total, sizes, prev, pager, next, jumper" :total="totalCount">
                </el-pagination>
            </div>
        </div>
        <!--标记说明-->
        <el-dialog  title="标记说明" :visible.sync="isSign" class="nopad" width="380px" >
            <el-form :model="form" status-icon ref="ruleForm" :rules="rules" label-width="85px" class="demo-ruleForm">
                <el-form-item label="标记说明" prop="processMemo" class="last-form-item">
                    <el-input type="textarea" v-model="form.processMemo"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button size="small" @click="isSign = !isSign">取 消</el-button>
                <el-button size="small" type="primary" @click="sureSign">确 定</el-button>
            </span>
        </el-dialog>

        <input v-model="copyText" ref="copy" style="position: fixed;left: -100%;top: -100%;" />

        <!-- 当前登录平台 -->
        <el-dialog title="当前登录平台" :visible.sync="dialogTableVisible">
            <el-table :data="platforms">
                <el-table-column type="index" label="序号"></el-table-column>
                <el-table-column property="platformName" label="平台名称"></el-table-column>
                <el-table-column property="account" label="帐号"></el-table-column>
            </el-table>
        </el-dialog>

    </div>
</template>

<script>
export default {
	name: 'queryRecord', //数据分析-查询记录
	data () {
		return {
            id: 0,
			getDataParam: {
                geGmtFeedback: '', //查询开始时间
                leGmtFeedback:'', //查询结束时间
                regionLike: '',
                productId: null,
                productNameLike: '',
                status: 'all', //状态
                page:1,
                size:10,
                platformCode: 'all',
                mobileLike: ""
            },
            platformList: [],
            totalDetail: {},
            dataList: [],
            time1: '',
            totalCount: 0,
            isSign:false,
            form: {
                processMemo: ''
            },
            rules: {
                processMemo: [{required:true,message:'请输入标记说明',trigger:'blur'},
                            { min: 1, max: 300, message: '长度在 1 到 300 个字符', trigger: 'blur' }]
            },
            dialogTableVisible: false, // 是否展示当前登录平台
            platforms: [], // 当前登录平台列表
            copyText: ''

		}
	},
	watch: {
	},
	methods: {
        clearForm () {
            this.form.processMemo = '';
            this.$refs.ruleForm.resetFields();
        },
		getDataList () {
            if (!!this.time1 && this.time1.length > 0) {
                this.getDataParam.geGmtFeedback = this.$root.format(this.time1[0]);
                this.getDataParam.leGmtFeedback = this.$root.format(this.time1[1]);
            } else {
                this.getDataParam.geGmtFeedback = "";
                this.getDataParam.leGmtFeedback = "";
            }
            let param = {...this.getDataParam};
            if (param.status === 'all') {
                param.status = null;
            }
            if (param.platformCode === 'all') {
                param.platformCode = null;
            }
            param.page = (param.page-1);
            this.$http('POST', '/admin/compare/feedback/page', {}, param, (status, res) => {
                if (status) {
                    if(!!res.content && res.content.length > 0) {
                        this.dataList = res.content;
                    }else {
                        this.dataList = [];
                    }
                    this.totalCount = res.totalCount;
                }
            })
        },
        searchGetDataList () {
            this.getDataParam.page = 1;
            this.getDataList();
        },
        changePageSize (val) {
            this.getDataParam.size = val;
            this.getDataParam.page = 1;
            this.getDataList();
        },
        getExport () {
            if (!!this.time1 && this.time1.length > 0) {
                this.getDataParam.geGmtFeedback = this.$root.format(this.time1[0]);
                this.getDataParam.leGmtFeedback = this.$root.format(this.time1[1]);
            } else {
                this.getDataParam.geGmtFeedback = "";
                this.getDataParam.leGmtFeedback = "";
            }
            let param = {...this.getDataParam};
            if (param.status === 'all') {
                param.status = null;
            }
            if (param.platformCode === 'all') {
                param.platformCode = null;
            }
            const loading = this.load();
            this.$http('POST', '/admin/compare/feedback/export', {}, param, (status, res) => {
                loading.close();
                if (status) {
                    if (res.status === '200') {
                        this.educe(res.data);
                    }
                }
            })
        },
        copyFunc (url) {
            this.copyText = url
            setTimeout(() => {
                this.$refs.copy.select()
                document.execCommand("Copy")
                this.success('复制成功')
            }, 100)
        },
        getAllPlatform () {
            this.$http('POST', '/admin/platform/all', {}, {}, (status, res) => {
                if (status) {
                    if (res.data && res.data.length > 0) {
                        this.platformList = res.data;
                    } else {
                        this.platformList = [];
                    }
                    this.getDataList();
                }
            })
        },
        stateHandling (item) {
            this.form.id = item.id;
            this.isSign = true;
        },
        sureSign () {
            this.$refs.ruleForm.validate( (status) => {
                if (status) {
                    this.$http('POST', '/admin/compare/feedback/process', {}, this.form, (status, res) => {
                        if (status) {
                            if (res.status === '200') {
                                this.$message({type: 'success', message: res.message});
                                this.isSign = false;
                                this.getDataList();
                            } else {
                                this.$message({type: 'error', message: res.message});
                            }
                        }
                    });
                }
            })
        },
	},
	mounted () {
        this.getAllPlatform();
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#queryRecord {width: 100%;height: calc(100vh - 132px);}
#queryRecord .content {height: calc(100% - 76px);}
#queryRecord .content .tab {height: calc(100% - 125px);}
#queryRecord >>>.el-table th.type>.cell, #queryRecord >>>.el-table td.type>.cell {margin-left: 75px;}
#queryRecord .copy-content{width: 5px; height: 5px; opacity: 0;}
</style>



// WEBPACK FOOTER //
// src/views/userSuggestions/errorBack.vue